export default __webpack_public_path__ + "static/media/card6.117bdc52.jpg";